import React from "react";

interface NumberedCardProps {
  number: number;
  children: React.ReactNode;
  className?: string;
}

export const NumberedCard: React.FC<NumberedCardProps> = ({
  number,
  children,
  className = "",
}) => {
  return (
    <div
      className={`relative flex items-center bg-black text-white rounded-xl px-6 py-4 shadow-lg min-w-[180px] ${className}`}
    >
      <div
        className="absolute -top-1 left-2.5 flex items-center justify-center text-[#0A5BFF] font-bold font-montserrat text-3xl scale-[2.3]"
        style={{ zIndex: 2 }}
      >
        {number}
      </div>
      <div className="flex-1 ml-5 text-center text-sm font-medium justify-self-end">
        {children}
      </div>
    </div>
  );
};

export default NumberedCard;
